// extracted by mini-css-extract-plugin
export var copyableField = "_nm-4";
export var customerBadge = "_nm-0";
export var customerInfoTitle = "_nm-2";
export var details = "_nm-1";
export var dropdownContainer = "_nm-5";
export var dropdownImage = "_nm-6";
export var editAssigneeForm = "_nm-a";
export var editButton = "_nm-3";
export var email = "_nm-7";
export var hidden = "_nm-d";
export var input = "_nm-8";
export var saveButton = "_nm-b";
export var shopifyIcon = "_nm-c";
export var suggestionBadge = "_nm-e";
export var suggestionText = "_nm-f";
export var username = "_nm-9";